import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { PacientesService } from 'src/app/shared/servicio/pacientes/pacientes.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-add-patients',
  templateUrl: './add-patients.component.html',
  styleUrls: ['./add-patients.component.css'],
})
export class AddPatientsComponent implements OnInit {
  @Output() addpatient = new EventEmitter();

  create_patients: FormGroup;
  preloader = false;
  selectecDni: any = null;
  selectSpecialties: any = null;
  specialties: any;
  submitted = false;
  paramDni: any[] = [
    { value: 'CC', name: 'Cédula de ciudadanía', id: 0 },
    { value: 'CE', name: 'Cédula de extranjería', id: 1 },
    { value: 'PA', name: 'Pasaporte', id: 3 },
  ];

  genderOptions: any[] = [
    { value: 'masculino', name: 'Masculino' },
    { value: 'femenino', name: 'Femenino' },
    { value: 'otros', name: 'Otro' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    public _pacientes: PacientesService,
    public _helper: HelpersService
  ) { }

  ngOnInit() {
    this.createForm();
    this.specialty_medic();
  }

  createForm() {
    this.create_patients = this.formBuilder.group({
      name: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],

      lastname: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],

      cell: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],

      dni: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],

      especialidad: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(50),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ. ]*'),
        ],
      ],
      dni_type: ['', [Validators.required]],
      // Campos opcionales - sin Validators.required
      gender: [''],
      birthdate: [''],
      email: ['', [Validators.email]] // Solo validación de formato de email, no requerido
    });
  }

  get shortCreate() {
    return this.create_patients.controls;
  }

  specialty_medic() {
    this._pacientes.especialidad_medico().subscribe((data) => {
      console.log(data);
      this.specialties = data;
    });
  }

  searchPatient() {
    const dni = this.shortCreate.dni.value;

    if (!dni) {
      this._helper.modalError('Por favor ingresa una cédula válida');
      return;
    }

    this._pacientes.getPatientDetail(dni).subscribe(
      (data) => {
        this.create_patients.patchValue({
          name: data.first_name || '',
          lastname: data.last_name || '',
          cell: data.cell || '',
          dni_type: data.dni_type || '',
          especialidad: data.specialty_name || '',
          email: data.email || '',
          gender: data.gender || '',
          birthdate: data.birthdate || '',
        });
        // Selección interna (usar tipo si lo provee tu API más adelante)
        this.selectSpecialties = null; // por si luego viene una especialidad

        console.log('Datos cargados:', data);
      },
      (error) => {
        console.error('No se encontró paciente', error);
        this._helper.modalError('Paciente no encontrado');
      }
    );
  }

  create() {
    // Resetear el estado de submitted y preloader al inicio
    this.submitted = true;

    // Validar tipo de cédula
    if (!this.shortCreate.dni_type.value) {
      this._helper.modalError('¡No has seleccionado tipo de cédula de la lista!');
      return;
    }

    // Validar especialidad seleccionada
    if (this.selectSpecialties === null) {
      this._helper.modalError('¡No has seleccionado especialidad de la lista!');
      return;
    }

    // Validar que el formulario sea válido
    if (!this.create_patients.valid) {
      this._helper.modalError('Por favor completa todos los campos requeridos correctamente');
      return;
    }

    // Mapear tipo de cédula
    const dniValue = this.shortCreate.dni_type.value;
    const dniMapped = this.paramDni.find(d => d.value === dniValue);

    if (!dniMapped) {
      this._helper.modalError('Tipo de cédula inválido');
      return;
    }

    // Activar preloader solo después de todas las validaciones
    this.preloader = true;

    // Preparar valores opcionales
    const emailValue = this.shortCreate.email.value.trim();
    const genderValue = this.shortCreate.gender.value.trim();
    const birthdateValue = this.shortCreate.birthdate.value.trim();

    this._pacientes.create_paciente(
      this.shortCreate.name.value,
      this.shortCreate.lastname.value,
      dniMapped.id,
      this.shortCreate.dni.value,
      this.shortCreate.cell.value,
      this.selectSpecialties['specialty_id__id'],
      emailValue,     // Puede ser undefined
      genderValue,    // Puede ser undefined
      birthdateValue  // Puede ser undefined
    ).subscribe(
      (data) => {
        this.preloader = false;
        this.submitted = false;
        this.addpatient.emit(true);
        this._helper.modalSuccess(data['message']);
        // Opcional: resetear el formulario después de éxito
        this.resetForm();
      },
      (error) => {
        this.preloader = false;
        this.submitted = false;
        this._helper.modalError(
          this._helper.splitErrorMessages(error.error, '<br>')
        );
      }
    );
  }

  // Método para resetear el formulario
  resetForm() {
    this.create_patients.reset();
    this.selectSpecialties = null;
    this.selectecDni = null;
    this.submitted = false;
  }

  clear(id) {
    if (id === 2) {
      if (this.shortCreate.especialidad.value != '') {
        this.shortCreate.especialidad.setValue(null);
        this.selectSpecialties = null; // También resetear la selección
      }
    }
  }

  onSelect2(event: TypeaheadMatch): void {
    this.selectSpecialties = event.item;
  }
}
